import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Layout from "../components/Layout";
import Slider from "react-slick";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
export default function HowItWorks() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
        style={{ transform: "rotate(180deg)" }}
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const reviewslide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Layout>
      <section className="profile-banner-sec main-page-works">
        <Container>
          <div className="how-works-content">
            <h2>How It Works</h2>
            <p>Three simple steps to honor your loved ones</p>

            <div className="how-works-cards">
              <div>
                <img
                  src={require("../assets/images/how-works-one.svg").default}
                />
                <h3>Scan QR/NFC</h3>
                <p>
                  Simply scan the QR code or tap the NFC tag to
                  <br /> access the memorial
                </p>
              </div>
              <div>
                <img
                  src={require("../assets/images/how-works-two.svg").default}
                />
                <h3>View Memorial</h3>
                <p>
                  Explore photos, stories, and cherished memories in
                  <br /> a beautiful digital space
                </p>
              </div>
              <div>
                <img
                  src={require("../assets/images/how-works-three.svg").default}
                />
                <h3>Share Tributes or Gifts</h3>
                <p>
                  Leave tributes, share memories, or send digital
                  <br /> AR gifts
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="watch-works-how-sec">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="watch-works-main">
                <h2>Watch How It Works ?</h2>
                <div className="">
                  <img src={require("../assets/images/howworks-mobile.png")} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="use-your-memory-sec">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="use-your-memory">
                <h2>Ways To Use Your Memory Medallion™?</h2>
                <p>
                  Experience the flexibility of Our Tributes in honouring your
                  loved ones. Our QR codes can be seamlessly embedded in a wide
                  range of memorials, from headstones that capture heartfelt{" "}
                  moments, to peaceful park benches, and personal urns, offering
                  a lasting and interactive tribute.
                </p>
                <div className="">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="Biography"
                  >
                    <div className="main-profile-tab">
                      <div className="main-profile-top">
                        <Nav
                          variant="pills"
                          className="gap-4 justify-content-center"
                        >
                          <Nav.Item>
                            <Nav.Link eventKey="Biography">Headstone</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Gallery">Park Bench</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Family">Cremation Urn</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                      <div className="main-profile-bottom">
                        <Tab.Content>
                          <Tab.Pane eventKey="Biography">
                            <div className="">
                              <img
                                src={require("../assets/images/howworks-mobile.png")}
                              />
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Gallery">
                            <div className="">
                              <img
                                src={require("../assets/images/howworks-mobile.png")}
                              />
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Family">
                            <div className="">
                              <img
                                src={require("../assets/images/howworks-mobile.png")}
                              />
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </div>
                    </div>
                  </Tab.Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="p-80">
        <Container>
          <div className="living-tribute-data">
            <h2>What Our Client Says</h2>

            <div className="review-slide">
              <Slider {...reviewslide}>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  );
}
